import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { setContactData, setConfirmationEmailData } from "../../reducers/contactAction";
import { ErrorMessage, Field } from "formik";

class ContactInputCard extends Component {

  setConfirmationEmailData(bool) {
    this.props.setConfirmationEmailData(bool);
    this.props.setFieldValue("confirmationEmail", bool);
  }

  render() {
    return (
      <div>
        <div className="card">
          <h3 className="card-header">Din kontaktinformation</h3>
          <div className="card-body">
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label htmlFor="firstName">Förnamn *</label>
                  <div className="input-group">
                    <Field
                      name="firstName"
                      type="text"
                      onBlur={e => {
                        // call the built-in handleBur
                        this.props.handleBlur(e);
                        this.props.setContactData({ first_name: e.target.value });
                      }}
                      className={ "form-control" + (this.props.errors.firstName && this.props.touched.firstName ? " is-invalid" : "") }
                    />
                    <ErrorMessage name="firstName" component="div" className="invalid-feedback" />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label htmlFor="lastName">Efternamn *</label>
                  <div className="input-group">
                    <Field
                      name="lastName"
                      type="text"
                      onBlur={e => {
                        // call the built-in handleBur
                        this.props.handleBlur(e);
                        this.props.setContactData({ last_name: e.target.value });
                      }}
                      className={ "form-control" + (this.props.errors.lastName && this.props.touched.lastName ? " is-invalid" : "")
                      }
                    />
                    <ErrorMessage name="lastName" component="div" className="invalid-feedback" />
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group">
                  <label htmlFor="email">E-post</label>
                  <div className="input-group">
                    <Field
                      name="email"
                      type="text"
                      onBlur={e => {
                        // call the built-in handleBur
                        this.props.handleBlur(e);
                        this.props.setContactData({ email: e.target.value });
                      }}
                      className={ "form-control" + (this.props.errors.email && this.props.touched.email ? " is-invalid" : "") }
                    />
                    <ErrorMessage name="email" component="div" className="invalid-feedback" />
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group">
                  <label htmlFor="phone">Telefon </label>
                  <div className="input-group">
                    <Field
                      name="phone"
                      type="text"
                      onBlur={e => {
                        // call the built-in handleBur
                        this.props.handleBlur(e);
                        this.props.setContactData({ phone: e.target.value });
                      }}
                      className={ "form-control" + (this.props.errors.phone && this.props.touched.phone ? " is-invalid" : "")
                      }
                    />
                    <ErrorMessage name="phone" component="div" className="invalid-feedback" />
                  </div>
                </div>
              </div>
              
              <div className="col-md-12">
                <div className="form-group">
                  <div className="custom-control custom-checkbox mr-1">
                    <input
                      type="checkbox"
                      className="custom-control-input"
                      onChange={() => this.props.setContactData({ confirmationEmail: !this.props.confirmationEmail }) }
                      id="checkboxConfirmationEmail"
                      checked={this.props.confirmationEmail}
                    />
                    <label className="custom-control-label" htmlFor="checkboxConfirmationEmail" >
                      Jag vill få en bekräftelse via epost
                    </label>
                    <Field name="confirmationEmail" type="hidden" className="form-control" />
                  </div>
                </div>
              </div>
              <div className="col-md-12">
                <div className="form-group">
                  <label htmlFor="socialSecurityNumber">Personnummer *</label>
                  <div className="input-group">
                    <Field
                      name="socialSecurityNumber"
                      type="text"
                      onBlur={e => {
                        // call the built-in handleBur
                        this.props.handleBlur(e);
                        this.props.setContactData({ social_security_number: e.target.value });
                      }}
                      className={
                        "form-control" +
                        (this.props.errors.socialSecurityNumber &&
                        this.props.touched.socialSecurityNumber
                          ? " is-invalid"
                          : "")
                      }
                    />
                    <ErrorMessage name="socialSecurityNumber" component="div" className="invalid-feedback" />
                  </div>
                  <p className="form-text">Formatet på personnummer ska vara enligt "ååååmmddxxxx"</p>
                  <small className="form-text text-muted">
                    <strong>Policy för personuppgifter</strong><br/>
                    <span>Personuppgifter som rör dig, och som du lämnar till oss eller som vi inhämtar på annat sätt, behandlas enligt gällande regelverk.</span>
                    <a className="link-complex" href="https://www.lansforsakringar.se/om-oss/kontakta-oss/sidfot/personuppgifter/" target="_blank">
                      <span className="link-complex-target">Så behandlar vi personuppgifter</span>
                    </a>
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="card">
          <h3 className="card-header">Adress till bostaden som ska försäkras</h3>
          <div className="card-body">
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label htmlFor="streetAddress">Gatuadress *</label>
                  <div className="input-group">
                    <Field
                      name="streetAddress"
                      type="text"
                      onBlur={e => {
                        // call the built-in handleBur
                        this.props.handleBlur(e);
                        this.props.setContactData({ street_address: e.target.value });
                      }}
                      className={
                        "form-control" +
                        (this.props.errors.streetAddress &&
                        this.props.touched.streetAddress
                          ? " is-invalid"
                          : "")
                      }
                    />
                    <ErrorMessage name="streetAddress" component="div" className="invalid-feedback" />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label htmlFor="zipCode">Postnummer *</label>
                  <div className="input-group">
                    <Field
                      name="zipCode"
                      type="text"
                      onBlur={e => {
                        // call the built-in handleBur
                        this.props.handleBlur(e);
                        this.props.setContactData({ zip_code: e.target.value });
                      }}
                      className={
                        "form-control" +
                        (this.props.errors.zipCode &&
                        this.props.touched.zipCode
                          ? " is-invalid"
                          : "")
                      }
                    />
                    <ErrorMessage name="zipCode" component="div" className="invalid-feedback" />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label htmlFor="mailingAddress">Postadress *</label>
                  <div className="input-group">
                    <Field
                      name="mailingAddress"
                      type="text"
                      
                      onBlur={e => {
                        // call the built-in handleBur
                        this.props.handleBlur(e);
                        this.props.setContactData({ mailing_address: e.target.value });
                      }}
                      className={
                        "form-control" +
                        (this.props.errors.mailingAddress && 
                        this.props.touched.mailingAddress
                          ? " is-invalid"
                          : "")
                      }
                    />
                    <ErrorMessage name="mailingAddress" component="div" className="invalid-feedback" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
                      
        <div className="card">
          <h3 className="card-header">
            Min nuvarande adress<br/>
            <small>(fyll i om du ännu inte har flyttat till bostaden som ska försäkras)</small>
          </h3>
          <div className="card-body">
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label htmlFor="currentStreetAddress">Gatuadress</label>
                  <div className="input-group">
                    <Field
                      name="currentStreetAddress"
                      type="text"
                      onBlur={e => {
                        // call the built-in handleBur
                        this.props.handleBlur(e);
                        this.props.setContactData({ current_street_address: e.target.value });
                      }}
                      className={
                        "form-control" +
                        (this.props.errors.currentStreetAddress && this.props.touched.currentStreetAddress ? " is-invalid" : "")
                      }
                    />
                    <ErrorMessage name="currentStreetAddress" component="div" className="invalid-feedback" />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label htmlFor="currentZipCode">Postnummer</label>
                  <div className="input-group">
                    <Field
                      name="currentZipCode"
                      type="text"
                      onBlur={e => {
                        // call the built-in handleBur
                        this.props.handleBlur(e);
                        this.props.setContactData({
                          current_zip_code: e.target.value
                        });
                      }}
                      className={
                        "form-control" +
                        (this.props.errors.currentZipCode && this.props.touched.currentZipCode ? " is-invalid" : "")
                      }
                    />
                    <ErrorMessage name="currentZipCode" component="div" className="invalid-feedback" />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label htmlFor="currentMailingAddress">Postadress</label>
                  <div className="input-group">
                    <Field
                      name="currentMailingAddress"
                      type="text"
                      onBlur={e => {
                        // call the built-in handleBur
                        this.props.handleBlur(e);
                        this.props.setContactData({ current_mailing_address: e.target.value });
                      }}
                      className={
                        "form-control" +
                        (this.props.errors.currentMailingAddress && this.props.touched.currentMailingAddress ? " is-invalid" : "")
                      }
                    />
                    <ErrorMessage
                      name="currentMailingAddress"
                      component="div"
                      className="invalid-feedback"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    first_name: state.contactReducer.first_name,
    last_name: state.contactReducer.last_name,
    phone: state.contactReducer.phone,
    email: state.contactReducer.email,
    social_security_number: state.contactReducer.social_security_number,
    street_address: state.contactReducer.street_address,
    zip_code: state.contactReducer.zip_code,
    mailing_address: state.contactReducer.mailing_address,
    municipality: state.contactReducer.municipality,
    current_street_address: state.contactReducer.current_street_address,
    current_zip_code: state.contactReducer.current_zip_code,
    current_mailing_address: state.contactReducer.current_mailing_address,
    confirmationEmail: state.contactReducer.contact_information.confirmationEmail
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setContactData: bindActionCreators(setContactData, dispatch),
    setConfirmationEmailData: bindActionCreators(setConfirmationEmailData, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ContactInputCard);
